import { useEffect } from 'react';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import CustomLink from '@/bit/components/components.custom-link';
import Button, {
  BUTTON_TYPE,
  BUTTON_WIDTH,
} from '@/bit/components/components.button';
import { ICON_ID } from '@gcloud-npm/utils.enums.icon-id';
import { COLOR_DICTIONARY } from '@gcloud-npm/utils.enums.colors';
import IconGlyph from '@/bit/components/components.icon-glyph';
import Page from '@/components/pageLayout';
import { sendTaggingInfo } from '@/utils/common';
import MetaData from '@/bit/core/core.meta-data';
import isColApp from '@gcloud-npm/utils.common.is-colapp';
import { DEFAULT_ERROR_PAGE_TEXT, PHONE_900 } from './constants';

function DefaultErrorPage({
  title = DEFAULT_ERROR_PAGE_TEXT.TITLE,
  description = DEFAULT_ERROR_PAGE_TEXT.DESCRIPTION,
  buttonHref = PHONE_900,
  buttonText = PHONE_900,
  buttonOnClick = null,
  iconId = ICON_ID.Alerta,
  iconColor = COLOR_DICTIONARY.RED,
  linkText = DEFAULT_ERROR_PAGE_TEXT.LINK_TEXT,
  linkUrl = DEFAULT_ERROR_PAGE_TEXT.LINK_URL,
  showLink = true,
  seoInfo,
  id = DEFAULT_ERROR_PAGE_TEXT.ERROR_ID,
  componentContent = 'none',
  columnForm = false,
}) {
  useEffect(() => {
    sendTaggingInfo(
      {
        componentName: id,
        componentVariation: 'none',
        componentContent,
        componentPerso: 'none',
        componentProduct: 'none',
      },
      'print-success'
    );
  }, []);
  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Page pageId={id} columnForm={columnForm}>
        <div className="container stopper">
          <div className="row">
            <div
              className={`${
                columnForm ? 'col-start-4--center' : 'col-start-4'
              } col-xs-12`}
            >
              <IconGlyph
                id={iconId}
                color={iconColor}
                layoutSize={{ height: 64, width: 64 }}
                kind="l"
              />
              <Text
                className="stopper__title"
                text={title}
                color={TEXT_COLOR.GREY6}
                kind={TEXT_KIND.HEADING}
                fontType={TEXT_FONT_WEIGHT.BOLD}
                size={TEXT_SIZE.TITLE4}
              />
              <Text
                className="stopper__subtitle"
                text={description}
                kind={TEXT_KIND.PARAGRAPH}
                color={TEXT_COLOR.GREY5}
                size={TEXT_SIZE.TITLE6}
              />
              {!isColApp() && (
                <div className="stopper__buttons">
                  <Button
                    href={!buttonOnClick ? buttonHref : ''}
                    onClick={buttonOnClick}
                    label={buttonText}
                    className="stopper__button"
                    type={BUTTON_TYPE.PRIMARY}
                    width={BUTTON_WIDTH.MEDIUM}
                    taggingInfo={{
                      componentName: 'button',
                      componentVariation: 'all',
                      componentContent: buttonText,
                      componentPerso: '',
                      componentProduct: '',
                    }}
                  />
                  {showLink && (
                    <CustomLink
                      className="stopper__link"
                      role="button"
                      onClick={() => {
                        window.location.href = linkUrl;
                      }}
                      taggingInfo={{
                        componentName: 'link',
                        componentVariation: 'all',
                        componentContent: linkText,
                        componentPerso: '',
                        componentProduct: '',
                      }}
                    >
                      <Text
                        text={linkText}
                        kind={TEXT_KIND.SPAN}
                        color={TEXT_COLOR.BLUEA}
                        display={TEXT_DISPLAY.INLINE}
                        size={TEXT_SIZE.CAPTION1}
                        fontType={TEXT_FONT_WEIGHT.REGULAR}
                      />
                    </CustomLink>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Page>
      <style jsx>
        {`
          .stopper {
            margin-top: auto;
            margin-bottom: auto;
            :global(.stopper__title) {
              margin-top: 20px;
              margin-bottom: 16px;
            }
            :global(.stopper__icon) {
              height: 64px;
            }
            .stopper__buttons {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin-top: 20px;
              margin-bottom: 16px;
              width: 100%;
              :global(.stopper__button) {
                width: 100%;
              }
              :global(.stopper__link) {
                margin-top: 16px;
              }
            }
          }
          @media screen and (min-width: 768px) {
            .stopper {
              .col-start-4 {
                grid-column-start: 3;
                grid-column-end: 12;
              }
              .col-start-4--center {
                display: flex;
                justify-content: center;
                flex-direction: column;
                justify-self: center;
              }
              .stopper__buttons {
                display: flex;
                flex-direction: row;
                justify-content: start;
                align-items: center;
                gap: 42px;
                width: 100%;
                :global(.stopper__button) {
                  width: auto;
                }
                :global(.stopper__link) {
                  margin-top: 0px;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
}

export default DefaultErrorPage;
